import {
  IconType,
  JWayIcon,
  PlusInCercleIcon,
} from "../../../assets/JWayIcons";
import styles from "./ButtonPlus.module.scss";

export interface ButtonMoreProps {
  label?: string;
  onClick?: () => void;
  color?: string;
  iconType?: IconType;
  iconSize?: number;
  children?: React.ReactNode;
}

/**
 * ButtonMore
 *
 * @param param0
 * @returns
 */
export default function ButtonPlus({
  label,
  onClick,
  color = "#5c5c5c",
  iconType,
  iconSize = 18,
  children,
}: ButtonMoreProps) {
  return (
    <button
      className={styles["button-more"]}
      onClick={onClick}
      style={{ color: color }}
    >
      <span className={styles["button-more__label"]}>{label}{children}</span>
      <div className={styles["button-more__icon"]}>
        {iconType ? (
          <JWayIcon type={iconType} size={iconSize} color={color} />
        ) : (
          <PlusInCercleIcon size={20} color={color} />
        )}
      </div>
    </button>
  );
}
